import React, { useState, useEffect } from 'react';
import { HiChevronLeft, HiChevronRight } from 'react-icons/hi';
import { motion } from 'framer-motion';

import { AppWrap, MotionWrap } from '../../wrapper';
import { urlFor, client } from '../../client';
// import './Testimonials.scss';

const Testimonial = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [testimonials, setTestimonials] = useState([]);
  const [brands, setBrands] = useState([]);

  const handleClick = (index) => {
    setCurrentIndex(index);
  };

  useEffect(() => {
    const query = '*[_type == "testimonials"]';
    const brandsQuery = '*[_type == "brands"]';

    client.fetch(query).then((data) => {
      setTestimonials(data);
    });

    client.fetch(brandsQuery).then((data) => {
      setBrands(data);
    });
  }, []);

  return (
    <>
      {testimonials.length && (
       
          
        
        <>
  

       
<div class=" mb-48 text-center max-w-6xl px-5 mx-auto mt-32">
    <h2 class="text-4xl  mb-4 font-bold text-indigo-600">Testimonials</h2>
    <h2 class="text-4xl font-bold text-center text-indigo-500 ">
          What's Different About me?
        </h2>
</div>
<div class="grid place-items-center  justify-center flex-nowrap">
    <div
            class="flex flex-col items-center p-6 space-y-6 rounded-lg bg-veryLightGray md:w-1/2"
          >
            <img src= {urlFor(testimonials[currentIndex].imgurl)}  class="w-16 -mt-14 rounded-full border-x-4" alt="" />
            <div>

 
            <h5 class="text-lg font-bold">{testimonials[currentIndex].name}</h5>
            <h3 className='text-sm text-center font-thin'>{testimonials[currentIndex].company}</h3>
            </div>
            <p class="text-sm text-darkGrayishBlue">
            {testimonials[currentIndex].feedback}
            </p>
    </div>
    
   
</div>
<div className="flex-row  flex items-center justify-center ">
            <div className="flex items-center justify-center  mt-4 h-12 m-4 w-12 bg-white rounded-full hover:bg-blue-600" onClick={() => handleClick(currentIndex === 0 ? testimonials.length - 1 : currentIndex - 1)}>
              <HiChevronLeft className='h-5 w-5 text-blue-700 hover:text-white ' />
            </div>

            <div  className="flex items-center justify-center mt-4 h-12 m-4 w-12 bg-white rounded-full hover:bg-blue-600" onClick={() => handleClick(currentIndex === testimonials.length - 1 ? 0 : currentIndex + 1)}>
              <HiChevronRight className='h-5 w-5 text-blue-800 hover:text-white' />
            </div>
          </div>

        </>
        

      )}

    
    </>
  );
};

export default AppWrap(
  MotionWrap(Testimonial, 'flex-col flex w-full'),
  'testimonial',
  'bg-gray-200',
);